import { useState } from 'react';
import { createContainer } from 'unstated-next';
import { getQuery } from '@src/public/utils/url';

// 列表相关的状态
const useListStore = (
    initialState = {
        // 时间线接口是否请求完成
        pageInitDone: false,
        // 时间线接口是否请求成功（http状态码非404即成功）
        pageOnline: true,
        // 用于端内卡片分享的网址二维码图片链接
        qrcode: '',
        // 列表是否在加载中
        listLoading: false,
        id: '',
        party: Number(getQuery(location.href, 'tabId')) || 0,
        highlights: 0,
        order: '',
        page: 1,
        size: 20,
        parties: [],
        total: 0,
        nodes: [],
        allowComment: false,
        title: '',
        summary: '',
        shareImgUrl: '',
        finish: 0,
        follow: false,
        // 全部展开状态
        allFold: false,
        // nav高度
        navHeight: 0,
        interactionRsp: null,
        // http状态
        online: true,
        // 是否展示弹幕
        showDanmu: false,
        // 是否展示分享长图
        showShareLongImg: false,
        // 直播流
        live: null,
        // 是否节流 0不节流 1节流
        cutOff: 0,
        // 后端配置直播数据信息
        liveInfo: null,
        // 流内第二条广告
        list2Ad: null
    },
) => {
    const [listStates, setListStates] = useState(initialState);

    const changeListStates = newListStates => {
        setListStates(prevStates => {
            return Object.assign({}, prevStates, newListStates);
        });
    };

    return { listStates, changeListStates };
};

export const ListStore = createContainer(useListStore);

// 总列表状态
const useStore = (
    initialState = {
        // 总列表
        nodes: [],
    },
) => {
    const [states, setStates] = useState(initialState);

    const changeStates = newStates => {
        setStates(states => Object.assign({}, states, newStates));
    };

    return { states, changeStates };
};

export const Store = createContainer(useStore);
